<div fxLayout="column" fxLayoutGap="10px" style="padding-bottom: 5px;">
  <mat-form-field floatLabel="never" class="p8-cm_data-table__search">
    <input matInput #filter
           [(ngModel)]="searchText"
           placeholder="saisir la révision souhaitée"
           matTooltip="saisir la révision souhaitée"
           type="number">
  </mat-form-field>

  <div>
    <button color="accent" class="mat-button mat-small" mat-raised-button (click)="onValidate($event)" matTooltip="Filtrer" [disabled]="! searchText" data-cy="btn-revision-deposits-filtering">Filtrer</button>&nbsp;
  </div>
</div>
